import React from "react";
import { Route, Routes } from "react-router-dom";
import { AuthInfo } from "./contexts/AuthInfoContext";
import { GeneralInfo } from "./contexts/GeneralInfoContext";
import { NegotiationInfo } from "./contexts/NegotiationContext";
import { PrivateInfo } from "./contexts/PrivateInfoContext";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import QuemSomos from "./pages/Login/QuemSomos";
import Notificacao from "./pages/Notificacao";
// import NotificacaoDoc from "./pages/N";
import Boletos from "./pages/MeusBoletos";
import PageNotFound from "./pages/PageNotFound";
import AuthRoute from "./routes/AuthRoute";
import ExternalRedirect from "./routes/ExternalRedirect";
import RedirectRoute from "./routes/RedirectRoute";

function RoutesIndex() {
  //const {mostrarFooter} = useGeneral()
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <RedirectRoute redirectTo="/dashboard">
              <GeneralInfo>
                <Login />
              </GeneralInfo>
            </RedirectRoute>
          }
        />
        <Route
          path="/quem-somos"
          element={
            <GeneralInfo>
              <QuemSomos />
            </GeneralInfo>
          }
        />
        <Route path="/notificacao/:valid" element={<Notificacao />} />
        {/* <Route path="/n/:valid" element={<NotificacaoDoc />} /> */}
        <Route path="/meusboletos/*" element={<ExternalRedirect to="https://club.direto.tech/app" />} />
        <Route path="/meusboletos-diretotech/" element={<Boletos />} />
        <Route
          path="/dashboard"
          element={
            <AuthRoute redirectTo="/">
              <AuthInfo>
                <GeneralInfo>
                  <PrivateInfo>
                    <NegotiationInfo>
                      <Dashboard />
                    </NegotiationInfo>
                  </PrivateInfo>
                </GeneralInfo>
              </AuthInfo>
            </AuthRoute>
          }
        />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}

export default RoutesIndex;
